import { DateTimeRangeTypes } from '@/models/common/date-time-range-types.model';
import { TopListShortcutNames } from '@/models/top-list/top-list-date-time-shortcut-names.model';
import { getDateTimeRange } from '@/utils/get-date-time-range.util';

export const TOP_LIST_DATE_TIME_SHORTCUTS = [
  {
    text: TopListShortcutNames.TODAY,
    value: () => getDateTimeRange(DateTimeRangeTypes.TODAY),
  },
  {
    text: TopListShortcutNames.YESTERDAY,
    value: () => getDateTimeRange(DateTimeRangeTypes.YESTERDAY),
  },
  {
    text: TopListShortcutNames.LAST_SEVEN_DAYS,
    value: () => getDateTimeRange(DateTimeRangeTypes.LAST_SEVEN_DAYS),
  },
  {
    text: TopListShortcutNames.THIS_MONTH,
    value: () => getDateTimeRange(DateTimeRangeTypes.THIS_MONTH),
  },
];
